/* eslint-disable */
import { getUploadLivraisonErrorMessage } from "../../../utils/uploadLivraisonError";
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { datat } from "./data";
import { datatZr } from "../../../utils/data_livraison/zrExpressV2/dataZr";
import { territoriesData } from "../../../utils/data_livraison/zrExpressV2/territories";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { setDoc, doc } from "firebase/firestore";
import {
  MapPin,
  Phone,
  Mail,
  X,
  Clock,
  CheckCircle,
  Building2,
} from "lucide-react";
import { db } from "../../../firebase";
import data_ecom_stopdesk from "../../../utils/data_livraison/data_ecom_stopdesk.json";
import getNoestCommuneFrenchName from "./noest/noestCommunes";

let noestDesksPromise = null;

const loadNoestDesks = async () => {
  if (!noestDesksPromise) {
    noestDesksPromise = fetch("/noest_desks.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Impossible de charger noest_desks.json");
        }
        return response.json();
      })
      .then((json) =>
        Object.entries(json || {}).map(([id, desk]) => ({
          ...desk,
          id,
        })),
      )
      .catch((error) => {
        noestDesksPromise = null;
        throw error;
      });
  }

  return noestDesksPromise;
};

const DeskModal = ({
  isOpen,
  onClose,
  onSelect,
  data,
  isMultiple = false,
  onCloseMultiple = null,
  onSelectMultiple = null,
  companyType = "noest",
  apiEndpoint,
  apiToken,
  userGuid,
  companyName = "Nord & Ouest",
  desksData = [],
  hubsHeaders = null,
  hubsSearchBody = null,
}) => {
  const { t: uiT } = useUiTranslation();
  const [desks, setDesks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDesk, setSelectedDesk] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [alreadyFetched, setAlreadyFetched] = useState(false);
  const previousIsOpenRef = React.useRef(isOpen);
  const store = useSelector((state) => state.StoreReducer);
  const [errorMessage, setErrorMessage] = useState("");

  const normalizedState = String(data?.state || "")
    .trim()
    .replace("إن صالح", "عين صالح")
    .toLowerCase();
  const wilayaCode =
    datat.find(
      (d) =>
        String(d.wilaya_name || "")
          .trim()
          .toLowerCase() === normalizedState ||
        String(d.wilaya_name_ascii || "")
          .trim()
          .toLowerCase() === normalizedState,
    )?.wilaya_code ?? "";
  const normalizedWilayaCode = String(Number(wilayaCode) || wilayaCode || "");

  const zrWilayaAscii = datatZr.find(
    (w) =>
      String(w.wilaya_name || "").trim() === String(data?.state || "").trim(),
  )?.wilaya_name_ascii;
  const zrCommuneAscii = datatZr.find(
    (c) =>
      String(c.commune_name || "").trim() ===
      String(data?.commune || "").trim(),
  )?.commune_name_ascii;

  const zrCityTerritoryId = territoriesData.items.find(
    (territory) =>
      territory.level === "wilaya" && territory.name === zrWilayaAscii,
  )?.id;

  const zrDistrictTerritoryId = territoriesData.items.find(
    (territory) =>
      territory.level === "commune" &&
      territory.name === zrCommuneAscii &&
      territory.parentId === zrCityTerritoryId,
  )?.id;

  // Filtrage adapté selon la compagnie
  const filteredDesks = desks.filter((desk) => {
    if (companyType === "noest") {
      const deskWilayaNumber = desk.code?.match(/^\d+/)?.[0] || "";
      return deskWilayaNumber === normalizedWilayaCode;
    } else if (companyType === "yalidine") {
      return (
        desk.wilaya_id === wilayaCode || desk.wilaya_id === Number(wilayaCode)
      );
    } else if (companyType === "ecomdelivery") {
      if (!wilayaCode) return true;
      return Number(desk.Ville) === Number(wilayaCode);
    } else if (companyType === "ecotrack") {
      return true;
    } else if (companyType === "zrexpress") {
      const isPickupPoint = desk?.isPickupPoint === true;
      if (!isPickupPoint) return false;

      if (!zrCityTerritoryId) {
        return true;
      }

      return (
        desk?.address?.cityTerritoryId === zrCityTerritoryId
        // &&
        // desk?.address?.districtTerritoryId === zrDistrictTerritoryId
      );
    }
    return true;
  });

  useEffect(() => {
    // Fetch desks seulement si le modal vient de s'ouvrir (false → true)
    const wasClosedNowOpen = !previousIsOpenRef.current && isOpen;
    previousIsOpenRef.current = isOpen;

    if (!isOpen || (alreadyFetched && !wasClosedNowOpen)) {
      setLoading(false);
      return;
    }

    const fetchDesks = async () => {
      setLoading(true);
      try {
        if (companyType === "noest") {
          const localDesks = await loadNoestDesks();
          setDesks(localDesks);
        } else if (companyType === "yalidine") {
          const response = await axios.get(apiEndpoint, {
            headers: {
              "yalidine-id": store.Yalidineid,
              "yalidine-token": store.Yalidinetoken,
              "wilaya-id": wilayaCode,
            },
          });
          setDesks(response.data.data || response.data || []);
        } else if (companyType === "ecomdelivery") {
          setDesks(Array.isArray(data_ecom_stopdesk) ? data_ecom_stopdesk : []);
        } else if (companyType === "ecotrack") {
          setDesks(Array.isArray(desksData) ? desksData : []);
        } else if (companyType === "zrexpress") {
          const response = await axios.post(
            apiEndpoint,
            hubsSearchBody || {
              pageSize: 1000,
              pageNumber: 1,
              includeServices: true,
            },
            {
              headers: {
                "Content-Type": "application/json",
                ...(hubsHeaders || {}),
              },
            },
          );
          setDesks(response?.data?.items || []);
        }
        setAlreadyFetched(true);
      } catch (error) {
        console.error(
          "❌ Erreur API desks :",
          error.response?.data || error.message,
        );
        setErrorMessage(uiT("ui.officeLoadError"));
      } finally {
        setLoading(false);
      }
    };

    fetchDesks();
  }, [isOpen, companyType, uiT]);

  // Réinitialiser le cache quand le modal se ferme
  useEffect(() => {
    if (!isOpen) {
      setAlreadyFetched(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (errorMessage) {
      Swal.fire({
        title: uiT("error"),
        text: errorMessage,
        icon: "error",
        confirmButtonText: uiT("ship.ok"),
        customClass: {
          popup: "rounded-xl",
          confirmButton:
            "bg-[#9e68ba] hover:bg-[#8b5aa3] text-white px-6 py-2 rounded-lg",
        },
      }).then(() => {
        setErrorMessage("");
      });
    }
  }, [errorMessage, uiT]);

  const envoyerCommande = async (
    stopDeskCode,
    communeName = "",
    isHomeDelivery = false,
  ) => {
    setSubmitting(true);
    const adresse = data.address || ".";
    let productDetails = "";

    if (Array.isArray(data.products) && data.products.length > 0) {
      data.products.forEach((product, index) => {
        let productName = product.name;
        const quantity = product.quantity;

        if (data.stockDelivery) {
          productDetails = product.sku;
          return;
        }

        if (data.products.length > 1 && productName.length > 15) {
          productName = productName.substring(0, 15) + "...";
        }

        const color = product.options?.color || "";
        const size = product.options?.size || "";
        const offer = product.options?.offer
          ? `العرض: ${product?.options?.offer}`
          : "";

        const details = `(${productName} × ${quantity} ${
          color && `+ ${color}`
        } ${size && `+ ${size}`} ${offer && `+ ${offer}`})`;

        productDetails += details;
        if (index < data.products.length - 1) {
          productDetails += " + ";
        }
      });
    }

    try {
      let response;
      let tracking;

      if (companyType === "noest") {
        response = await axios.post(
          "https://app.noest-dz.com/api/public/create/order",
          {
            station_code: stopDeskCode,
            user_guid: store.Userguid,
            api_token: store.ApitokenNord,
            type_id: 1,
            stop_desk: isHomeDelivery ? 0 : data.stopdeskDelivery ? 1 : 0,
            produit: productDetails,
            client: data.name,
            phone: data.phone,
            quantite: `${data.qty}`,
            adresse: adresse,
            wilaya_id: wilayaCode,
            commune: isHomeDelivery
              ? data.state || ""
              : getNoestCommuneFrenchName(data.commune, wilayaCode) ||
                datat.find((d) => d.commune_name === data.commune)
                  ?.commune_name_ascii ||
                "",
            montant: data.total,
            NoteClient: data.note,
            Remboursement: 0,
            poids: "0",
          },
        );
        tracking = response.data.tracking || null;
      } else if (companyType === "yalidine") {
        const postData = {
          keyword: "yalidine",
          data: [
            {
              order_id: "MyFirstOrder",
              center_code: stopDeskCode,
              firstname: ".",
              familyname: data.name,
              contact_phone: data.phone,
              address: adresse,
              to_commune_name: communeName,
              to_wilaya_name:
                datat.find((d) => d.wilaya_name === data.state)
                  ?.wilaya_name_ascii ?? "",
              product_list: `${productDetails}`,
              price: data.total,
              do_insurance: false,
              declared_value: data.total,
              freeshipping: data.deliveryPrice == 0 ? true : false,
              is_stopdesk: isHomeDelivery ? false : !!data.stopdeskDelivery,
              stopdesk_id: isHomeDelivery ? "" : stopDeskCode,
              has_exchange: false,
              product_to_collect: null,
            },
          ],
        };

        response = await axios.post(
          "https://backend.foorweb.store/api/UploadLivraison",
          postData,
          {
            headers: {
              "yalidine-id": store.Yalidineid,
              "yalidine-token": store.Yalidinetoken,
              "Content-Type": "application/json",
            },
          },
        );

        tracking = response.data?.data?.MyFirstOrder?.tracking || null;
      }

      const deliveryStatus = "4";
      await setDoc(doc(db, "orders", data.id), {
        ...data,
        deleveryStatus: deliveryStatus,
        DC: "5",
        tracking: tracking,
        selectedDesk: stopDeskCode,
        deliveryCompany: companyType,
        ...(isHomeDelivery && { stopdeskDelivery: false, commune: data.state }),
      });

      // Succès avec animation
      Swal.fire({
        title: uiT("ui.orderSent"),
        text: uiT("ui.orderSentVia", { value0: companyName }),
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
        customClass: {
          popup: "rounded-xl",
        },
      });

      if (isMultiple) {
        onSelectMultiple(stopDeskCode);
      } else {
        onSelect(stopDeskCode);
      }
      onClose();
    } catch (error) {
      console.error("❌ Erreur lors de l'envoi de la commande :", error);
      setErrorMessage(
        getUploadLivraisonErrorMessage(error) || (error.response?.data?.error ||
          error.response?.data?.message ||
          "حدث خطأ أثناء إرسال الطلب"),
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleDeskSelect = (desk) => {
    setSelectedDesk(desk);
  };

  const handleConfirm = () => {
    if (selectedDesk) {
      console.log("Selected Desk:", selectedDesk);
      if (companyType === "noest") {
        const stationCode = selectedDesk.code || selectedDesk.id;
        if (!stationCode) {
          setErrorMessage(uiT("ui.noestOfficeCodeError"));
          return;
        }
        envoyerCommande(stationCode);
      } else if (companyType === "ecomdelivery") {
        const selectedCode = selectedDesk.Code || selectedDesk.code;
        if (isMultiple) {
          onSelectMultiple(selectedCode);
        } else {
          onSelect(selectedCode);
        }
        onClose();
      } else if (companyType === "ecotrack") {
        if (isMultiple) {
          onSelectMultiple(selectedDesk);
        } else {
          onSelect(selectedDesk);
        }
        onClose();
      } else if (companyType === "zrexpress") {
        const selectedHub = {
          id: selectedDesk.id,
          name: selectedDesk.name || "",
          address: selectedDesk.address || {},
        };
        if (isMultiple) {
          onSelectMultiple(selectedHub);
        } else {
          onSelect(selectedHub);
        }
        onClose();
      } else {
        envoyerCommande(
          selectedDesk.center_id || selectedDesk.code,
          selectedDesk.commune_name,
        );
      }
    }
  };

  const handleHomeDelivery = () => {
    envoyerCommande("", data.state || "", true);
  };

  const getDeskName = (desk) => {
    if (companyType === "noest") {
      return desk.name;
    } else if (companyType === "yalidine") {
      return desk.name;
    } else if (companyType === "ecomdelivery") {
      return desk.Libelle || desk.name || "";
    } else if (companyType === "ecotrack") {
      return desk.name || "";
    } else if (companyType === "zrexpress") {
      return desk.name || desk.address?.district || desk.address?.city || "Hub";
    }
    return "";
  };

  // Fonction pour obtenir le code du bureau
  const getDeskCode = (desk) => {
    if (companyType === "noest") {
      return desk.code;
    } else if (companyType === "yalidine") {
      return desk.center_id || desk.code;
    } else if (companyType === "ecomdelivery") {
      return desk.Code || desk.code;
    } else if (companyType === "ecotrack") {
      return desk.name || "--";
    } else if (companyType === "zrexpress") {
      return desk.id || "--";
    }
    return "";
  };

  // Fonction pour obtenir l'adresse
  const getDeskAddress = (desk) => {
    if (companyType === "noest") {
      return desk.address;
    } else if (companyType === "yalidine") {
      return desk.address;
    } else if (companyType === "ecomdelivery") {
      return desk.Adresse || desk.address || "";
    } else if (companyType === "ecotrack") {
      const price = desk.price != null ? desk.price : "";
      return price === "" ? "" : `Prix: ${price}`;
    } else if (companyType === "zrexpress") {
      const street = desk.address?.street || "";
      const district = desk.address?.district || "";
      const city = desk.address?.city || "";
      return [street, district, city].filter(Boolean).join(", ");
    }
    return "";
  };

  // Fonction pour obtenir les téléphones
  const getDeskPhones = (desk) => {
    if (companyType === "noest") {
      return desk.phones
        ? Object.values(desk.phones).filter((phone) => phone)
        : [];
    } else if (companyType === "yalidine") {
      return desk.phone ? [desk.phone] : [];
    } else if (companyType === "zrexpress") {
      return [
        desk?.phone?.number1,
        desk?.phone?.number2,
        desk?.phone?.number3,
      ].filter(Boolean);
    }
    return [];
  };

  // Fonction pour obtenir le lien GPS/Map
  const getDeskMapLink = (desk) => {
    if (companyType === "noest") {
      return desk.map;
    } else if (companyType === "yalidine") {
      // Convertir les coordonnées GPS en lien Google Maps
      if (desk.gps) {
        const [lat, lng] = desk.gps.split(",");
        return `https://www.google.com/maps?q=${lat},${lng}`;
      }
    } else if (companyType === "zrexpress") {
      const lat = desk?.address?.coordinates?.lat;
      const lng = desk?.address?.coordinates?.lng;
      if (lat != null && lng != null) {
        return `https://www.google.com/maps?q=${lat},${lng}`;
      }
    }
    return null;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50 p-4">
      <div className="bg-white dark:!bg-[#181919] border border-transparent dark:!border-[#3c3a3d] rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="p-6 border-b border-gray-200 dark:!border-[#3c3a3d] relative">
          <button
            onClick={onClose}
            className="absolute right-6 top-6 p-2 hover:bg-gray-100 dark:hover:bg-[#3c3a3d] rounded-lg transition-colors"
            disabled={submitting}
          >
            <X className="w-5 h-5 text-gray-600 dark:text-gray-400" />
          </button>

          <div className="flex items-center mb-2">
            <Building2 size={20} className="text-[#9e68ba] ml-2" />
            <h3 className="text-lg font-semibold text-gray-800 dark:!text-white">
              {uiT("ui.selectOfficeTitle")} {companyName}
            </h3>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            {uiT("ui.selectOfficeIn")} {data?.state}
          </p>
        </div>

        {/* Content */}
        <div className="p-6">
          {loading ? (
            <div className="flex flex-col items-center justify-center py-12">
              <Clock className="w-12 h-12 animate-spin text-[#9e68ba] mb-4" />
              <p className="text-gray-600 dark:text-gray-400">
                {uiT("ui.loadingOffices")}
              </p>
            </div>
          ) : filteredDesks.length === 0 ? (
            <div className="text-center py-12">
              <Building2 className="w-16 h-16 text-gray-300 dark:text-gray-600 mx-auto mb-4" />
              <p className="text-gray-600 dark:text-gray-400 text-lg">
                {uiT("ui.noOffices")}
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-500 mt-2">
                {uiT("ui.noOfficesInState")}
              </p>
              {(companyType === "noest" || companyType === "yalidine") && (
                <button
                  type="button"
                  className="mt-6 px-6 py-3 bg-[#9e68ba] hover:bg-[#8b5aa3] text-white rounded-lg font-medium transition-colors disabled:opacity-50"
                  onClick={handleHomeDelivery}
                  disabled={submitting}
                >
                  {submitting
                    ? uiT("services.foorCall.submitting")
                    : uiT("ui.sendHomeDelivery")}
                </button>
              )}
            </div>
          ) : (
            <div className="space-y-4">
              <div className="p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
                <p className="text-sm text-blue-700 dark:text-blue-300">
                  <strong>{uiT("ui.availableLabel")}</strong>{" "}
                  {filteredDesks.length} {uiT("ui.officesInState")}
                </p>
              </div>

              <div className="max-h-96 overflow-y-auto space-y-3">
                {filteredDesks.map((desk, index) => {
                  const deskCode = getDeskCode(desk);
                  const isSelected = selectedDesk
                    ? getDeskCode(selectedDesk) === deskCode
                    : false;
                  const mapLink = getDeskMapLink(desk);

                  return (
                    <div
                      key={index}
                      className={`p-4 border rounded-lg cursor-pointer transition-all duration-200 hover:shadow-md ${
                        isSelected
                          ? "border-[#9e68ba] bg-purple-50 dark:bg-purple-900/20"
                          : "border-gray-300 dark:!border-[#3c3a3d] bg-white dark:!bg-[#141414] hover:border-[#9e68ba]"
                      }`}
                      onClick={() => handleDeskSelect(desk)}
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="flex items-center gap-3 mb-3">
                            <div
                              className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                                isSelected
                                  ? "border-[#9e68ba] bg-[#9e68ba]"
                                  : "border-gray-300 dark:border-gray-600"
                              }`}
                            >
                              {isSelected && (
                                <CheckCircle className="w-3 h-3 text-white" />
                              )}
                            </div>
                            <h4 className="font-semibold text-gray-800 dark:!text-white">
                              {getDeskName(desk)}
                            </h4>
                            <span className="text-xs bg-gray-100 dark:bg-[#3c3a3d] text-gray-600 dark:text-gray-400 px-2 py-1 rounded">
                              {deskCode}
                            </span>
                          </div>

                          <div className="space-y-2 text-sm">
                            <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
                              <MapPin className="w-4 h-4 text-[#9e68ba]" />
                              <span>{getDeskAddress(desk)}</span>
                            </div>

                            {companyType === "yalidine" &&
                              desk.commune_name && (
                                <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
                                  <Building2 className="w-4 h-4 text-[#9e68ba]" />
                                  <span>
                                    {desk.commune_name}, {desk.wilaya_name}
                                  </span>
                                </div>
                              )}

                            {getDeskPhones(desk).length > 0 && (
                              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
                                <Phone className="w-4 h-4 text-[#9e68ba]" />
                                <div className="flex gap-2">
                                  {getDeskPhones(desk)
                                    .slice(0, 2)
                                    .map((phone, i) => (
                                      <span
                                        key={i}
                                        className="text-[#9e68ba] hover:underline cursor-pointer"
                                      >
                                        {phone}
                                      </span>
                                    ))}
                                </div>
                              </div>
                            )}

                            {desk.email && (
                              <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400">
                                <Mail className="w-4 h-4 text-[#9e68ba]" />
                                <span className="text-[#9e68ba]">
                                  {desk.email}
                                </span>
                              </div>
                            )}

                            {mapLink && (
                              <div className="pt-2">
                                <a
                                  href={mapLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-sm text-[#9e68ba] hover:text-[#8b5aa3] hover:underline inline-flex items-center gap-1"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <MapPin className="w-3 h-3" />
                                  {uiT("ui.showMap")}
                                </a>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        {!loading && filteredDesks.length > 0 && (
          <div className="p-6 border-t border-gray-200 dark:!border-[#3c3a3d] flex gap-3">
            <button
              className="flex-1 py-3 bg-gray-200 dark:bg-[#3c3a3d] rounded-lg font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-[#4c4a4d] transition-colors disabled:opacity-50"
              onClick={onClose}
              disabled={submitting}
            >
              {uiT("annule")}
            </button>
            <button
              className={`flex-1 py-3 rounded-lg font-medium transition-all duration-200 flex items-center justify-center gap-2 ${
                selectedDesk
                  ? "bg-[#9e68ba] hover:bg-[#8b5aa3] text-white"
                  : "bg-gray-300 dark:bg-[#3c3a3d] text-gray-500 dark:text-gray-600 cursor-not-allowed"
              }`}
              onClick={handleConfirm}
              disabled={!selectedDesk || submitting}
            >
              {submitting ? (
                <>
                  <Clock className="w-4 h-4 animate-spin" />
                  {uiT("services.foorCall.submitting")}
                </>
              ) : (
                <>
                  <CheckCircle className="w-4 h-4" />
                  {uiT("ui.confirmSelection")}
                </>
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeskModal;
